import { Icon } from './Icon'
import { Select } from './Select'
import type { Attendant } from '../domain/types'

// Seletor de atendente (resourceId). Obrigatório no legado antes de chamar/iniciar;
// com allowAll vira o filtro "ver só os meus" (comportamento #10).
export function AttendantSelect({ attendants, value, onChange, allowAll, compact }: {
  attendants: Attendant[]
  value: string | null
  onChange: (id: string | null) => void
  allowAll?: boolean
  compact?: boolean
}) {
  const hasAttendants = attendants.length > 0
  const options = [
    allowAll
      ? { value: '', label: 'Todos os atendentes' }
      : { value: '', label: hasAttendants ? 'Selecione o atendente...' : 'Nenhum atendente disponível', disabled: true },
    ...attendants.map((a) => ({ value: a.id, label: a.nome })),
  ]
  return (
    <div className={'fz-attendant ' + (compact ? 'fz-attendant--compact ' : '') + (!allowAll && !hasAttendants ? 'is-disabled' : '')}>
      <Icon name="user" size={14} className="fz-attendant__icon" />
      <Select
        value={value ?? ''}
        options={options}
        onChange={(id) => onChange(id || null)}
        ariaLabel="Selecionar atendente"
        compact={compact}
        disabled={!allowAll && !hasAttendants}
      />
    </div>
  )
}
